import { render, staticRenderFns } from "./DRSTNavigationBar.vue?vue&type=template&id=406183cc&"
import script from "./DRSTNavigationBar.vue?vue&type=script&lang=ts&"
export * from "./DRSTNavigationBar.vue?vue&type=script&lang=ts&"
import style0 from "./DRSTNavigationBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406183cc')) {
      api.createRecord('406183cc', component.options)
    } else {
      api.reload('406183cc', component.options)
    }
    module.hot.accept("./DRSTNavigationBar.vue?vue&type=template&id=406183cc&", function () {
      api.rerender('406183cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/DRSTNavigationBar.vue"
export default component.exports